var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-padding not-mobile"},[_c('h1',[_vm._v(_vm._s(_vm.$store.strings.general_title))]),_c('p',[_vm._v(_vm._s(_vm.$store.strings.general_notMobile))])])}
var staticRenderFns = []

export { render, staticRenderFns }